import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export default function ScenarioButtonDeleteDialog({
  deletionInfo,
  targetType = "scene",
  onCancel,
  onKeepScene,
  onDeleteScene,
}) {
  const open = Boolean(deletionInfo);
  if (!open) return null;

  const targetLabel = deletionInfo.targetSceneLabel;
  const hasOtherIncomingButtons = deletionInfo.hasOtherIncomingButtons;
  const isQuestion = targetType === "question";
  const targetPhrase = isQuestion
    ? `на вопрос «${targetLabel}»`
    : `в сцену «${targetLabel}»`;
  const targetNoun = isQuestion ? "вопрос" : "сцену";

  return (
    <Dialog open onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Удалить кнопку?</DialogTitle>
      <DialogContent>
        <p>
          {hasOtherIncomingButtons
            ? `Кнопка ведёт ${targetPhrase}, куда ведут и другие кнопки. Остальные связи сохранятся.`
            : `Кнопка ведёт ${targetPhrase}. Выберите, оставить ${targetNoun} в проекте или удалить её вместе с кнопкой.`}
        </p>
        {deletionInfo.canDeleteScene && deletionInfo.hasChildButtons ? (
          <p>
            Кнопки внутри этого элемента тоже будут удалены. Другие сцены, к
            которым они ведут, останутся в проекте.
          </p>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ flexWrap: "wrap", gap: 1, px: 3, pb: 2 }}>
        <Button onClick={onCancel}>Отмена</Button>
        <Button variant="outlined" onClick={onKeepScene}>
          {hasOtherIncomingButtons
            ? "Удалить только эту кнопку"
            : `Оставить ${targetNoun} без связи`}
        </Button>
        {deletionInfo.canDeleteScene ? (
          <Button color="error" variant="contained" onClick={onDeleteScene}>
            Удалить также {targetNoun}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}
